import * as d3 from "d3";
import dataD3ComponentMixin from "./data-d3-component-mixin.js";
//TODO: faire un tooltip: https://www.datathis.tooltipCanvas.fr/index.php?page=tooltipLinearchart
// interesting example : https://bl.ocks.org/larsenmtl/e3b8b7c2ca4787f77d78f58d41c3da91

export default {
  mixins: [dataD3ComponentMixin],
  data() {
    return {
      tooltipCreated: false,
      colorRect: "white",
    };
  },
  methods: {
    deleteTooltip() {
      this.dom_canvas.selectAll(".tooltip-container").remove();
      this.tooltipCreated = false;
    },

    createTooltip: function (event) {
      // Checks if the event comes from an interactive zone
      var t = event.target;

      var interactive = false;
      while (t !== undefined && t !== null) {
        if (t.classList && t.classList.contains("interactive_zone")) {
          interactive = true;
        }

        t = t.parentNode;
      }
      if (!interactive) {
        this.deleteTooltip();
        return;
      }

      // https://stackoverflow.com/questions/11334452/event-offsetx-in-firefox
      var target = event.target || event.srcElement;
      var rect = target.getBoundingClientRect();
      var offsetX =
        (event.clientX - rect.left) * (this.graphWidth / rect.width);
      var offsetY =
        (event.clientY - rect.top) * (this.graphHeight / rect.height);
      var texte;
      if (this.Is_data_abscisse && this.typeScale != "log") {
        texte = this.calcTooltipTextPlot(offsetX, offsetY);
      } else {
        texte = this.calcTooltipText(offsetX, offsetY);
      }

      if (texte != -1) {
        if (this.tooltipCreated) this.deleteTooltip();
        this.calcTooltipCircle(offsetX, offsetY);

        this.createLine(offsetX, offsetY, texte);
        this.tooltipCreated = true;
      }
    },
    calcTooltipCircle(offsetX, offsetY) {
      var on_circle = false;
      this.dom_canvas.selectAll("circle").each(function () {
        const thisD3 = d3.select(this);

        if (
          parseInt(thisD3.attr("cx")) + 10 > offsetX &&
          parseInt(thisD3.attr("cx")) - 10 < offsetX
          // parseInt(thisD3.attr("cy")) + 10 > offsetY &&
          // parseInt(thisD3.attr("cy")) - 10 < offsetY
        ) {
          thisD3.attr("stroke", thisD3.attr("fill"));
          thisD3.attr("stroke-width", 3);
          thisD3.attr("opacity", 1);
          on_circle = true;
        } else {
          thisD3.attr("stroke-width", 0);
          thisD3.attr("opacity", 0.5);
        }
      }, on_circle);
      return on_circle;
    },
    // Calcule le texte de la tooltip
    calcTooltipText: function (offsetX, offsetY) {
      var texte = new Object();
      var position = 0;
      Object.keys(this.objectData).forEach((flux_identifier) => {
        if (this.getVisibility(flux_identifier)) {
          var flux_structure = this.getFluxStructure(flux_identifier);
          position = this.calcTooltipPosition(offsetX, offsetY, flux_structure);
          var data = flux_structure.data;
          if (this.typeScale == "log") {
            //https://stackoverflow.com/questions/8586216/linear-x-logarithmic-scale
            var logMax = Math.log10(
              this.d3_xRange.domain()[1] / this.d3_xRange.domain()[0]
            );
            var puiss = (logMax * offsetX) / this.graphWidth;
            var definitive = this.d3_xRange.domain()[0] * 10 ** puiss;
            var bisect = d3.bisector((d) => {
              return JSON.parse(d.raw_value)[`${this.Is_data_abscisse}`];
            }).left;
            position = bisect(data, definitive) - 1;
          }

          if (data[position] != undefined) {
            if (this.Is_data_abscisse) {
              var raw_value_to_json = JSON.parse(data[position].raw_value);
              texte[this.Is_data_abscisse] = {
                text: `${this.tx(this.Is_data_abscisse)}:${
                  raw_value_to_json[`${this.Is_data_abscisse}`]
                }`,
                color: "gray",
              };
            } else {
              texte["time"] = {
                text: `time:${data[position].time}`,
                color: "gray",
              };
            }

            texte[flux_identifier] = {
              text: `${
                flux_structure.attributes.label
                  ? flux_structure.attributes.label
                  : flux_identifier
              }:${parseFloat(data[position].number_value).toFixed(2)}`,
              color: flux_structure.attributes.color,
            };
          }
        }
      }, this);

      return position != -1 ? texte : -1;
    },
    // Calcule le texte de la tooltip si elle est positionnée sur un point (dot)
    calcTooltipTextPlot: function (offsetX, offsetY) {
      var texte = new Object();
      var position = 0;
      var nextposition = 0;
      var textpoint = {};
      Object.keys(this.objectData).forEach((flux_identifier) => {
        var flux_structure = this.getFluxStructure(flux_identifier);
        var data = flux_structure.data;

        position = this.calcTooltipPositionPlot(
          offsetX,
          offsetY,
          flux_structure
        );
        nextposition = parseInt(position) + 1;
        var rawjson = JSON.parse(data[position].raw_value);
        var nextrawjson = JSON.parse(data[nextposition].raw_value);
        var interval =
          nextrawjson[`${this.Is_data_abscisse}`] -
          rawjson[`${this.Is_data_abscisse}`];

        var texte_calculated = null;
        var texte_calculated_y = null;
        var coord_x =
          ((this.d3_xRange.domain()[1] - this.d3_xRange.domain()[0]) *
            offsetX) /
            this.graphWidth +
          this.d3_xRange.domain()[0];
        var coef_position =
          (coord_x - rawjson[`${this.Is_data_abscisse}`]) / interval;
        var coord_y =
          (data[nextposition].number_value - data[position].number_value) *
            coef_position +
          data[position].number_value;

        texte_calculated = coord_x.toFixed(this.config.attributes.precision);
        texte_calculated_y = coord_y.toFixed(this.config.attributes.precision);

        // quel est le point le plus proche de la tooltip? :
        if (
          coord_x - rawjson[`${this.Is_data_abscisse}`] <
          nextrawjson[`${this.Is_data_abscisse}`] - coord_x
        ) {
          textpoint =
            rawjson[`${this.Is_data_abscisse}`].toFixed(
              this.config.attributes.precision
            ) +
            ";" +
            data[position].number_value.toFixed(
              this.config.attributes.precision
            );
        } else {
          textpoint =
            nextrawjson[`${this.Is_data_abscisse}`].toFixed(
              this.config.attributes.precision
            ) +
            ";" +
            data[nextposition].number_value.toFixed(
              this.config.attributes.precision
            );
        }
        texte["abscisse"] = {
          text: `${this.tx(this.Is_data_abscisse)}:${texte_calculated}`,
          color: flux_structure.attributes.color,
        };

        texte[flux_identifier] = {
          text: `${flux_structure.attributes.legend_y}:${texte_calculated_y}`,
          color: flux_structure.attributes.color,
        };
        if (this.calcTooltipCircle(offsetX, offsetY)) {
          this.colorRect = flux_structure.attributes.color;
          texte[flux_structure.attributes.name] = {
            text: `point ${flux_structure.attributes.name}:${textpoint}`,
            color: flux_structure.attributes.color,
          };
        } else {
          this.colorRect = "gray";
        }
      }, this);
      return position != -1 ? texte : -1;
    },
    // fonction qui crée le tooltip
    //(ligne de position + texte legende à chaque evenement move dans un histogramComponent)
    createLine(positionX, positionY, texte) {
      // je declare le dom_canvas dans la variable tooltipCanvas
      var tooltipCanvas = this.dom_canvas
        .append("svg:svg")
        .attr("class", "tooltip-container")
        .style("fill", "gray")
        .style("font-size", "5px")
        .attr("width", this.graphWidth)
        .attr("height", this.graphHeight + this.margin.top + this.margin.bottom)
        .append("svg:g");
      // je crée une ligne svg ayant une classe définie (afin de la selectionner par la suite et de ne pas agir sur TOUTES les lignes du graph)
      // je la déplace en fonction de la position de la souris rapporté par histogramComponent sur l'axe des abscisses  (la hauteur est quand à elle figée)
      tooltipCanvas
        // line irregular example: https://www.dbface.com/assets/echarts/doc/example/line7.html#macarons-en
        .append("line")
        //.attr("class", "tooltipLine-per-mouse")
        .attr("x1", "0")
        .attr("y1", "0")
        .attr("x2", "0")
        .attr("y2", this.graphHeight)
        .attr("stroke", "gray")
        .attr("stroke-dasharray", 1)
        .attr("stroke-width", "1")
        .attr("transform", "translate(" + positionX + ",0)");

      // création d'un element text svg qui supportera les éléments tspan par la suite ( tspan pour avoir des sauts de lignes)
      // calcul du rapporchement du texte par rapport au bord droit du graphique afin de décaler le texte vers la gauche pour
      // continuer à la voir avec les variables ecart, this.reliquat et gap_tooltipLegend
      var distance_from_edge = this.graphWidth - positionX;
      var distance_from_line = 5;
      var lineHeight = 10;
      var max_tooltipLegend_length = 0;
      var box_height =
        lineHeight * Object.keys(texte).length + 2 * distance_from_line;
      var box_position_x = positionX;
      var box_position_y = positionY;

      for (var entry of Object.values(texte)) {
        var tooltipLegend_length = entry.text.length * 3.2;
        if (max_tooltipLegend_length < tooltipLegend_length)
          max_tooltipLegend_length = tooltipLegend_length;
      }
      var box_width = max_tooltipLegend_length + 2 * distance_from_line;
      if (distance_from_edge < max_tooltipLegend_length + distance_from_line) {
        box_position_x = positionX - box_width;
      }
      // Création d'un rectangle permettant d'avoir un background pour le texte
      tooltipCanvas
        .append("svg:rect") // append a rect to catch mouse movements on canvas
        .attr("width", box_width) // can't catch mouse events on a g element
        .attr("height", box_height)
        .attr("fill", "white")
        .attr("stroke", this.colorRect)
        .attr("stroke-width", "0.5px")
        .attr("opacity", "0.8")
        .attr(
          "transform",
          "translate(" + box_position_x + "," + box_position_y + ")"
        );

      var text_position_x = box_position_x + distance_from_line;
      var text_position_y = box_position_y;

      // data va accueillir dans un tableau les données de chaque flux (nom et valeur)
      var i = 0;

      // boucle qui crée autant d'éléments tspan qu'il y a de flux et donc de données dans l'objet qui est donnée
      // à la fonction createtooltipLine. Les espaces entre les lignes sont définis dans l'attr y.
      for (entry of Object.values(texte)) {
        tooltipCanvas
          .append("text")
          //.attr("class", "text-per-mouse")
          //.style("font-size", "6px")
          //.style("stroke", "gray")
          .attr("x", 0)
          .attr("y", (i + 1) * lineHeight + 2)
          .style("stroke", entry.color)
          .style("stroke-width", "0.1px")
          .text(entry.text)
          .attr(
            "transform",
            "translate(" + text_position_x + "," + text_position_y + ")"
          );
        i += 1;
      }

      // l'élément rect de svg est  crée ici pour avoir un écouteur actif sur les évènements souris du graph
      // sans cet élément le comportement n'est pas cleui attendu ( la ligne subit un net décalage tooltipCanvasuel avec la position de la souris)
      tooltipCanvas
        .append("svg:rect") // append a rect to catch mouse movements on canvas
        .attr("width", this.graphWidth) // can't catch mouse events on a g element
        .attr("height", this.graphHeight)
        .attr("fill", "none")
        .attr("pointer-events", "all")
        .on("mouseover", function () {
          d3.mouse(this);
        });
    },

    calcTooltipPosition(positionX, positionY, dataForFlux) {
      var checkPosition = 0;
      // data stocke les données pour chaque flux issus de histogramComponent

      var data = dataForFlux.data;
      if (data[0] != undefined) {
        //if ( dataForFlux.length > 0 ){
        // verifPosition va analyser la valeur de l'abscisse pointée par la barre verticale tooltip
        // règle de trois qui entre position souris en abscisse, taille en pixels des abscisses au total et temps maximum au bout des abscisses
        // ce qui nous ramène le temps à la position de la souris
        var verifPosition = Math.round(
          positionX * (this.time_range / this.graphWidth)
        );

        for (var j in data) {
          if (data[j].time < verifPosition) {
            checkPosition = j;
          }
        }

        return checkPosition != data.length - 1 ? checkPosition : -1;
      }
    },
    calcTooltipPositionPlot(positionX, positionY, dataForFlux) {
      var checkPosition = 0;
      var listCheckPosition = null;
      var data = dataForFlux.data;
      var verifPosition =
        positionX *
        ((this.d3_xRange.domain()[1] - this.d3_xRange.domain()[0]) /
          this.graphWidth);
      for (var i in data) {
        var raw = data[i].raw_value;
        var rawjson = JSON.parse(raw);
        if (i != data.length - 1) {
          if (
            rawjson[this.Is_data_abscisse] <
            this.d3_xRange.domain()[0] + verifPosition
          ) {
            checkPosition = i;
          }
          var j = parseInt(i) + 1;
          if (
            JSON.parse(data[j].raw_value)[this.Is_data_abscisse] <
            rawjson[this.Is_data_abscisse]
          ) {
            listCheckPosition = listCheckPosition + `${checkPosition}`;
          }
        }
      }
      return checkPosition != data.length - 1 ? checkPosition : -1;
    },
  },
};
